import React from "react";
import clsx from "clsx";
import NumberInput from "../NumberInput/NumberInput";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import SeasonTypeDataType from "../DataTable/dataTypes/SeasonTypeDataType";
import numeral from "numeral";
import DisabledLineItem from "../DataTable/dataTypes/DisabledLineItem";
import DateHelper from "../DateHelper/DateHelper";
import { format } from "date-fns";
import { parseISO } from "date-fns";

class SeasonalPriceBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      start_date: this.props.room_type_price
        ? DateHelper.isDateObject(this.props.room_type_price.start_date)
          ? this.props.room_type_price.start_date
          : parseISO(this.props.room_type_price.start_date)
        : null,
    };

    this.onChange = this.onChange.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });

    var days_of_week = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    var days = days_of_week.map((day_of_week) =>
      this.renderDayOfWeek(day_of_week)
    );
    var base_price = days_of_week.map((day_of_week) =>
      this.renderBasePrice(day_of_week)
    );

    if (this.props.room_type.type_of_booking != 'daily') {
      var min_stay = days_of_week.map((day_of_week) =>
        this.renderDailyMinimumStay(day_of_week)
      );
    }
     

    return (
      <div className={tabClasses} id="general">
        <div className="card well-md">
          <div className="row" style={{ marginBottom: 20 }}>
            {this.renderSeasonOrRoomType()}
            {this.renderRemoveButton()}
          </div>

          <div className="container-fluid" style={{ overflowX: "scroll" }}>
            <div className="row" style={{ minWidth: "800px" }}>
              <div
                className="col-md-2 col-sm-2 col-xs-2"
                style={{ width: "12%", marginRight: "20px" }}
              >
                <label>{I18n.t("override")}</label>
              </div>
              {days}
            </div>

            <div
              className="row"
              style={{ marginTop: "10px", minWidth: "800px" }}
            >
              <div
                className="col-md-2 col-sm-2 col-xs-2"
                style={{ width: "12%", marginRight: "20px" }}
              >
                <label>{`${I18n.t("base_price")}*`}</label>
                <div>
                  {format(this.state.start_date, this.state.dateFormat)}
                </div>
              </div>
              {base_price}
            </div>
            {
              this.props.room_type && this.props.room_type.type_of_booking != 'daily' 
                ?
              <div className="row" style={{ marginTop: "10px", minWidth: "800px" }}>
                <div className="col-md-2 col-sm-2 col-xs-2"style={{ width: "12%", marginRight: "20px" }}>
                  <label style={{ whiteSpace: "nowrap" }}>{`${I18n.t(
                    "minimum_stay"
                  )}*`}</label>
                </div>

                {min_stay}
              </div>

                :
              null
            }
            

          </div>
          <div>*{I18n.t("seasonal_price_minimum_stay_helper_text")}</div>
        </div>
      </div>
    );
  }

  renderSeasonOrRoomType() {
    if (this.props.view_type == "room_type_price") {
      return (
        <div>
          <div className="col-md">
            <label>{I18n.t("room_type")}</label>
            {this.props.room_type.status == "disabled" ? (
              <DisabledLineItem
                data={this.props.room_type}
                disabledRoomType={true}
              />
            ) : (
              <div>
                <span style={{ display: "inline" }}>
                  <a
                    className="modal-iframe"
                    style={{ display: "inline" }}
                    data-fullscreen="true"
                    data-nested="true"
                    href={this.props.season.edit_admin_room_type_prices_path}
                  >
                    {this.props.room_type.name}
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="col-md-2" style={{ width: "14.2857%" }}>
            <label>{I18n.t("season")}</label>
            <div>{this.props.season.name}</div>
          </div>
          <div className="col-md-8" style={{ width: "68.4285%" }}>
            <label>{I18n.t("season_type")}</label>
            <SeasonTypeDataType
              date_format={this.props.date_format}
              row={this.props.season}
            />
          </div>
        </div>
      );
    }
  }

  renderDayOfWeek(day_of_week) {
    return (
      <div className="col-sm" style={{ width: "12%" }} key={day_of_week}>
        <label>{I18n.t(day_of_week)}</label>
      </div>
    );
  }

  renderDailyMinimumStay(day_of_week) {
    var min_stay_name = day_of_week + "_minimum_stay";
    return (
      <div className="col-sm" style={{ width: "12%" }} key={min_stay_name}>
        <div className={this.renderFieldClasses(min_stay_name, "input-group")}>
          <NumberInput
            className={`${this.props.errors && this.props.errors[min_stay_name] ? "form-control has-errors" : "form-control"}`}
            name={min_stay_name}
            onChange={this.onChange}
            value={this.props[min_stay_name]}
          />
        </div>
        {this.props.room_type_price &&
        this.props.room_type_price[min_stay_name] ? (
          <div className="text-center" style={{ marginTop: 5, color: "#777" }}>
            {this.props.room_type_price[min_stay_name]} {I18n.t("night")}{" "}
            {I18n.t("min_stay")}
          </div>
        ) : null}
        {this.renderFieldErrors(min_stay_name)}
        {day_of_week == "sunday" ? (
          <div className="form-group">
            <a
              className="primary"
              style={{ cursor: "pointer" }}
              onClick={(e) =>
                this.props.onChangeAllMinimumStays(
                  this.props.sunday_minimum_stay,
                  this.props.room_type_id
                )
              }
            >
              {I18n.t("apply_to_all")}
            </a>
          </div>
        ) : null}
      </div>
    );
  }

  renderBasePrice(day_of_week) {
    var base_price = day_of_week + "_amount";
    return (
      <div className="col-sm" style={{ width: "12%" }} key={base_price}>
        <div
          className={this.renderFieldClasses(
            base_price,
            "input-group input-group-currency"
          )}
        >
          <CurrencyInput
            className={`${this.props.errors && this.props.errors[base_price] ? "form-control has-errors" : "form-control"}`}
            name={base_price}
            onChange={this.onChange}
            value={this.props[base_price]}
            onChangeEventType={true}
            nested={false}
          />
        </div>
        {this.props.room_type_price ? (
          <div className="text-center" style={{ marginTop: 5, color: "#777" }}>
            <em>
              {this.props.room_type_price[base_price]
                ? numeral(this.props.room_type_price[base_price] / 100).format(
                    "0,0.00"
                  )
                : ""}
            </em>
          </div>
        ) : null}
        {this.renderFieldErrors(base_price)}
        {day_of_week == "sunday" ? (
          <div className="form-group">
            <a
              className="primary"
              style={{ cursor: "pointer" }}
              onClick={(e) =>
                this.props.onChangeAllDays(
                  this.props.sunday_amount,
                  this.props.room_type_id
                )
              }
            >
              {I18n.t("apply_to_all")}
            </a>
          </div>
        ) : null}
      </div>
    );
  }

  renderRemoveButton() {
    if (
      this.props.read_only != true &&
      typeof this.props.onRemove == "function"
    ) {
      return (
        <div className="col-md flexed content-right seasonal-price-remove">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.props.onRemove.bind(this, this.props.id)}
          >
            {I18n.t("remove")}
          </button>
        </div>
      );
    }

    return null;
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });

      return <div className="help-block">{errors}</div>;
    }
  }

  renderFieldClasses(field, classnames) {
    var classname = classnames || "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  onChange(event) {
    if (typeof this.props.onChange == "function") {
      var seasonal_price = {
        id: this.props.id || "-0",
        season: this.props.season || null,
        season_id:
          this.props.season_id ||
          (this.props.season ? this.props.season.id : "-0"),
        room_type: this.props.room_type || {},
        room_type_id: this.props.room_type_id || null,
        room_type_price: this.props.room_type_price || null,
        room_type_price_id: this.props.room_type_price_id || "-0",
        sunday_amount: this.props.sunday_amount || "",
        monday_amount: this.props.monday_amount || "",
        tuesday_amount: this.props.tuesday_amount || "",
        wednesday_amount: this.props.wednesday_amount || "",
        thursday_amount: this.props.thursday_amount || "",
        friday_amount: this.props.friday_amount || "",
        saturday_amount: this.props.saturday_amount || "",
        sunday_minimum_stay: this.props.sunday_minimum_stay || "",
        monday_minimum_stay: this.props.monday_minimum_stay || "",
        tuesday_minimum_stay: this.props.tuesday_minimum_stay || "",
        wednesday_minimum_stay: this.props.wednesday_minimum_stay || "",
        thursday_minimum_stay: this.props.thursday_minimum_stay || "",
        friday_minimum_stay: this.props.friday_minimum_stay || "",
        saturday_minimum_stay: this.props.saturday_minimum_stay || "",
      };

      seasonal_price[event.target.name] = event.target.value;

      this.props.onChange(seasonal_price);
    }
  }
}

export default SeasonalPriceBuilder;
